import React from 'react';
import { ComplianceIssueRow } from '../callCenterComplianceIssuesTypes';
import { PriorityBadge, StatusBadge, ViewButton, IssueCard } from '../../shared';
import sharedStyles from '../../shared/IssueTable.module.css';
import styles from './ComplianceIssuesTable.module.css';

interface ComplianceIssuesTableProps {
  rows: ComplianceIssueRow[];
  onView?: (id: string) => void;
}

export const ComplianceIssuesTable: React.FC<ComplianceIssuesTableProps> = ({ rows, onView }) => {
  return (
    <IssueCard title="Compliance Issues">
      <div className={sharedStyles.tableWrap}>
        <table className={sharedStyles.table}>
          <thead>
            <tr>
              <th>TICKET ID</th>
              <th>CUSTOMER</th>
              <th>PRODUCT CATEGORY</th>
              <th>VIOLATION TYPE</th>
              <th>PRIORITY</th>
              <th>STATUS</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className={sharedStyles.ticketId}>{row.ticketId}</td>
                <td className={sharedStyles.bold}>{row.customer}</td>
                <td>{row.productCategory}</td>
                <td className={styles.violation}>{row.violationType}</td>
                <td>
                  <PriorityBadge priority={row.priority} />
                </td>
                <td>
                  <StatusBadge status={row.status} />
                </td>
                <td>
                  <ViewButton onClick={() => onView?.(row.id)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </IssueCard>
  );
};
